module.exports = __webpack_public_path__ + "Bg_reports_Summer.5e845fd0f7185f3e0a98e5ece4e62480.png";